import Lottie from "lottie-react";
import upcomingAnimation from "../../../loader/subscription.json"; // reuse same or add new animation
import { motion, useAnimation } from "framer-motion";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const EmptyUpcomingSubscription = () => {
  const navigate = useNavigate();
  const controls = useAnimation();

  useEffect(() => {
    const sequence = async () => {
      await controls.start("visible");
      controls.start({
        y: [0, -10, 0],
        transition: {
          repeat: Infinity,
          repeatType: "reverse",
          duration: 2,
          ease: "easeInOut",
        },
      });
    };
    sequence();
  }, [controls]);

  const container = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { staggerChildren: 0.1 },
    },
  };

  const item = {
    hidden: { y: 20, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: { type: "spring", damping: 10, stiffness: 80 },
    },
  };

  return (
    <motion.div
      className="flex flex-col items-center justify-center h-[60vh] text-center px-3"
      variants={container}
      initial="hidden"
      animate={controls}
    >
      <div className="relative mb-6">
        <motion.div
          animate={{ scale: [1, 1.05, 1] }}
          transition={{
            repeat: Infinity,
            repeatType: "reverse",
            duration: 2,
            ease: "easeInOut",
          }}
        >
          <Lottie animationData={upcomingAnimation} loop className="w-32 h-32" />
          <div className="absolute inset-0 bg-[#FF7236] rounded-full opacity-10 blur-lg scale-110" />
        </motion.div>
      </div>

      <motion.h2 variants={item} className="text-2xl sm:text-3xl font-bold text-primary">
        No Upcoming Plans Scheduled
      </motion.h2>
      <motion.p variants={item} className="text-sm sm:text-base text-gray-600 max-w-md mt-2 mb-6">
        You haven’t scheduled a future plan yet. Upgrade now to ensure continuous access!
      </motion.p>

      <motion.button
        variants={item}
        onClick={() => navigate("/membershipPlans")}
        className="px-6 py-3 border-2 border-primary rounded-full text-primary font-medium relative overflow-hidden group bg-white"
        whileHover={{
          scale: 1.05,
          backgroundColor: "#FF7236",
          color: "#fff",
          boxShadow: "0 10px 25px rgba(255, 114, 54, 0.3)",
        }}
        whileTap={{ scale: 0.95 }}
      >
        Browse Plans
      </motion.button>
    </motion.div>
  );
};

export default EmptyUpcomingSubscription;
